"use strict";
class CrowdfundingStats extends HTMLElement {
    constructor() {
        super();
        this.backersElement = this.querySelector("[data-backers]");
        this.backedElement = this.querySelector("[data-backed]");
        this.backedPercentageElement = this.querySelector("[data-backed-percentage]");
        this.targetAmountElement = this.querySelector("[data-target]");
        this.progressBarElement = this.querySelector("[data-progress]");
    }
    maybeRender(element, content) {
        if (!element) {
            return;
        }
        element.innerText = content;
    }
    render({ backed, backers, backedPercentage, target }) {
        const currencyFormatter = Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
        });
        const percentageFormatter = Intl.NumberFormat("pt-BR", {
            style: "percent",
            maximumFractionDigits: 2
        });
        const formattedBackedAmount = currencyFormatter.format(backed !== null && backed !== void 0 ? backed : 0);
        const formattedTargetAmount = currencyFormatter.format(target !== null && target !== void 0 ? target : 0);
        const formattedBackedPercentage = percentageFormatter.format((backedPercentage !== null && backedPercentage !== void 0 ? backedPercentage : 0) / 100);
        this.maybeRender(this.backersElement, String(backers));
        this.maybeRender(this.backedElement, formattedBackedAmount);
        this.maybeRender(this.targetAmountElement, formattedTargetAmount);
        this.maybeRender(this.backedPercentageElement, formattedBackedPercentage);
        if (this.progressBarElement) {
            this.progressBarElement.style.setProperty("--progress-bar-width", `${backedPercentage !== null && backedPercentage !== void 0 ? backedPercentage : 0}%`);
        }
    }
    connectedCallback() {
        fetch("https://app.soucorneta.com.br/api/v1/p/crowdfunding", {
            cache: "no-store",
        })
            .then((r) => {
            return r.json();
        })
            .then((json) => {
            this.render(json);
            setTimeout(() => {
                this.dataset.loading = 'false';
            }, 400);
        });
    }
}
customElements.define("crowdfunding-stats", CrowdfundingStats);